import { render, staticRenderFns } from "./CommunityAdsBrandView.vue?vue&type=template&id=1f1e0c4c&scoped=true"
import script from "./CommunityAdsBrandView.vue?vue&type=script&lang=js"
export * from "./CommunityAdsBrandView.vue?vue&type=script&lang=js"
import style0 from "./CommunityAdsBrandView.vue?vue&type=style&index=0&id=1f1e0c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e0c4c",
  null
  
)

export default component.exports